import * as React from "react";
import { useState } from "react";

export const FormSection = ({ title, children, defaultExpanded = true, isOpen: controlledIsOpen, onToggle }) => {
  const [isOpen, setIsOpen] = useState(defaultExpanded);

  // If parent provides a controlled `isOpen`, sync local state
  React.useEffect(() => {
    if (typeof controlledIsOpen === 'boolean') {
      setIsOpen(controlledIsOpen);
    }
  }, [controlledIsOpen]);

  const toggle = () => {
    const next = !isOpen;
    setIsOpen(next);
    if (typeof onToggle === 'function') onToggle(next);
  };

  return (
    <div className="flex flex-col px-5 gap-3 py-4 mt-4 w-full font-semibold bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">
      {/* Header */}
      <div
        className="w-full text-xl font-semibold flex items-center justify-between cursor-pointer"
        onClick={toggle}
      >
        {title}
        <svg
          className={`w-5 h-5 text-gray-600 transform transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>

      {/* Collapsible content */}
      {isOpen && (
        <div className="flex flex-col gap-3 mt-0 w-full text-sm">{children}</div>
      )}
    </div>
  );
};
